module.exports = __webpack_public_path__ + "static/media/qm.64b1f2d7.svg";